import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import {
    fetchTypeaheadDevicesForFilter,
    clearTypeahed
} from '../../../actions';
import MultiTypeahead from './MultiTypeahead';

class LicensesVmMultiTypeahead extends Component {
    static propTypes = {
        fetchTypeaheadDevicesForFilter: PropTypes.func.isRequired,
        clearTypeahed: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        renderMultiSuggestion: PropTypes.func,
    };

    static defaultProps = {
        suggestions: []
    };

    constructor(props) {
        super(props);
        this.handleSuggestionsFetchRequested = this.handleSuggestionsFetchRequestedFilter.bind(this);
    }

    handleSuggestionsFetchRequestedFilter = term => {
        this.props.fetchTypeaheadDevicesForFilter(LicensesVmMultiTypeahead.name, { term });
    };

    render() {
        const options = this.props.suggestions.map(device => ({
            label: device.deviceNumber,
            value: device.id
        }));
        return (
            <MultiTypeahead
                options={options}
                isMulti
                value={this.props.value}
                error={this.props.error}
                titleId="virtualMachine"
                animatedPlaceholder
                handleSuggestionsClearRequested={this.props.clearTypeahed}
                handleSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                onChangeSuggestion={this.props.onChangeSuggestion}
                formatOptionLabel={this.props.renderMultiSuggestion}
                t={this.props.t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === LicensesVmMultiTypeahead.name
            ? typeahead.list
            : LicensesVmMultiTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchTypeaheadDevicesForFilter,
    clearTypeahed
})(LicensesVmMultiTypeahead);
